import React, { useState } from 'react';
import { config } from '@triare/auth-redux';
import { Modal } from 'antd';
import Simple from '../../../components/Layout/Simple';
import ResetPasswordContent from '../../../components/Pages/Auth/ResetPassword';
import Layout from '../../../components/Layout';
import Home from '../../../components/Pages/Home';

const { displayName } = config;

export default function ResetPassword(): React.ReactElement {
  document.title = `${displayName}: New Password`;
  const [isModalOpen, setIsModalOpen] = useState(true);

  return (
    <Layout>
      <Modal
        open={isModalOpen}
        footer={false}
        closable={false}
        onCancel={() => setIsModalOpen(false)}
      >
        <ResetPasswordContent closeModal={() => setIsModalOpen(false)} />
      </Modal>
      <Home />
    </Layout>
  );
}
